<template>
  <div class="main-wrapper party-edit">
    <v-container>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title primary-title>
              ECO Portal Exports
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    clearable
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-data-table
                    :headers="headers"
                    :items="ecoPortalIntegrationExports"
                    class="elevation-0"
                    :loading="ecoPortalIntegrationApiLoading"
                    :options.sync="options"
                    :page.sync="page"
                    :server-items-length="totalExports"
                    hide-default-footer
                  >
                    <template #item.created_at="{ item }">
                      {{ item.created_at | formatDateTime }}
                    </template>
                  </v-data-table>

                  <div class="text-center mt-4">
                    <v-pagination
                      v-model="page"
                      :length="pageCount"
                      :total-visible="8"
                      circle
                    />
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { INTEGRATION_NAMESPACE } from '@/store/integrations'

export default {
  name: 'ECOPortalExports',

  data () {
    return {
      headers: [
        {
          align: 'start',
          sortable: false,
          text: 'ID',
          value: 'id',
        },
        { sortable: false, text: 'Legal Case', value: 'legal_case.name' },
        { sortable: false, text: 'Created By', value: 'initiated_by.name' },
        { sortable: false, text: 'Created At', value: 'created_at' },
      ],

      itemsPerPage: 15,
      options: {},
      page: 1,
      search: '',
      searchDebounce: null,
    }
  },

  computed: {
    pageCount () {
      return Math.ceil(this.totalExports / this.itemsPerPage) || 0
    },

    totalExports () {
      return this.ecoPortalIntegrationPaginator?.count || 0
    },

    ...mapGetters(INTEGRATION_NAMESPACE, [
      'ecoPortalIntegrationApiLoading',
      'ecoPortalIntegrationExports',
      'ecoPortalIntegrationPaginator',
    ]),
  },

  watch: {
    options: {
      handler () {
        this.fetch()
      },

      deep: true,
    },

    search () {
      this.page = 1

      if (this.searchDebounce) clearTimeout(this.searchDebounce)
      this.searchDebounce = setTimeout(_ => this.fetch(), 500)
    },
  },

  created () {
    this.fetch()
  },

  methods: {
    fetch () {
      this.fetchEcoPortalExports({
        itemsPerPage: this.itemsPerPage,
        page: this.page,
        search_term: this.search || undefined,
      })
    },

    ...mapActions(INTEGRATION_NAMESPACE, [
      'fetchEcoPortalExports',
    ]),
  },
}
</script>
